export default __webpack_public_path__ + "static/media/team46.0437f058.JPG";